/* eslint-disable import/no-cycle */
import { call, put, takeEvery, all, select } from 'redux-saga/effects';
import { user, course, stock, magicLink } from '../../api/api';
import {
  INIT_APPLICATION,
  INIT_APPLICATION_SUCCESS,
  INIT_APPLICATION_FAILURE,
  REFRESH_TOKEN,
  SWITCH_ACCOUNT_TYPE,
  SWITCH_ACCOUNT_TYPE_SUCCESS
} from './initActions';

import { CREATE_TOKEN_SUCCESS } from '../signin/signinActions';

import logger from '../../utils/logger';
import history from '../../router/history';
import { displayInfo, displaySuccess } from '../../utils/toast/Toast';

const getCurrentAccountInformations = state =>
  state.init.currentAccountInformations;

export function* initApplication() {
  try {
    let isStockHandled = false;
    let companyStock;
    const [currentUserInformations, usedCarrier, currentCourse] = yield all([
      call(user.getCurrentUserInformations),
      call(user.getUsedCarriers),
      call(course.getCurrentCourse)
    ]);
    const productBarcode = yield call(stock.getProductBarcode);
    if (currentUserInformations.data.user.company) {
      const { company } = currentUserInformations.data.user;
      if (company.contract && company.contract.stockManagement) {
        const response = yield call(stock.getIsStockHandled, {
          companyExternalId: currentUserInformations.data.user.company.id
        });
        const stockResponse = yield call(
          stock.getStock,
          currentUserInformations.data.user.company.id
        );
        companyStock = stockResponse.data.products;
        isStockHandled = response.data.isStockHandled; // eslint-disable-line prefer-destructuring
      }
    }

    yield put({
      type: INIT_APPLICATION_SUCCESS,
      payload: {
        ...currentUserInformations.data,
        ...currentCourse.data,
        ...productBarcode.data,
        usedCarrier: usedCarrier?.data?.carriers || [],
        stock: companyStock,
        isStockHandled
      }
    });

    const { accountType, userHasTwoAccounts } = yield select(
      getCurrentAccountInformations
    );
    if (userHasTwoAccounts) {
      displaySuccess(
        `Vous êtes connecté à votre compte ${
          accountType === 'particular' ? 'particulier' : 'professionel'
        } pour changer de compte rendez-vous dans la section Mon profile > Type de compte`
      );
    }
  } catch (error) {
    logger(error);
    yield put({ type: INIT_APPLICATION_FAILURE });
  }
}

export function* refreshToken(action) {
  try {
    const response = yield call(magicLink.refreshToken, action.payload);
    const account = {
      userHasTwoAccounts: !!(
        response.data.professional && response.data.individual
      ),
      accountType: 'particular',
      professionalToken: response.data.professional
        ? response.data.professional.token
        : null,
      individualToken: response.data.individual
        ? response.data.individual.token
        : null
    };
    if (response.data.success === true) {
      if (response.data.professional) {
        localStorage.setItem('token', response.data.professional.token);
        account.accountType = 'professional';
      } else {
        localStorage.setItem('token', response.data.individual.token);
        account.accountType = 'particular';
      }
      yield put({ type: CREATE_TOKEN_SUCCESS, payload: account });
      yield put({ type: 'RESET_SIGNIN_REDUCER' });
    }
    yield call(initApplication);
    yield call(history.push, '/not-sent');
  } catch (error) {
    logger(error);
  }
}

export function* switchAccountType(action) {
  displayInfo('Changement de votre type de compte');
  localStorage.setItem('token', action.payload.token);
  yield put({
    type: SWITCH_ACCOUNT_TYPE_SUCCESS,
    payload: action.payload.accountType
  });
  yield call(initApplication);
  yield call(history.push, '/not-sent');
}

const signinSaga = [
  takeEvery(INIT_APPLICATION, initApplication),
  takeEvery(REFRESH_TOKEN, refreshToken),
  takeEvery(SWITCH_ACCOUNT_TYPE, switchAccountType)
];

export default signinSaga;
